import { isNonEmptyString } from '@/utils/checks'
import { Center } from '@/types/models'
import {
  FOCUS_BOOST,
  NON_FOCUS_PENALTY,
  MATCHED_EATING_DISORDERS_BOOST,
  MATCHED_BEHAVIORAL_ADDICTION_BOOST,
  MATCHED_MENTAL_HEALTH_BOOST
} from './constants'
import {
  isBrowsePageType,
  isLocationPageType
} from '@/domain/useCases/pageTypeCheck'
import { PrimaryFocus } from '@/domain/primaryFocus/constant'
import { PageType } from '@/types/models/PageType.model'

export const adjustPrimaryFocus = ({
  center,
  primaryFocus,
  pageType
}: {
  center: Center
  primaryFocus?: string
  pageType?: PageType
}): number => {
  if (
    !isNonEmptyString(primaryFocus) &&
    isLocationPageType(pageType ?? '') &&
    center?.primaryFocus.includes('Substance Use')
  ) {
    return FOCUS_BOOST
  }
  if (
    !isNonEmptyString(center?.primaryFocus) ||
    !isNonEmptyString(primaryFocus)
  ) {
    return NON_FOCUS_PENALTY
  }
  if (
    isBrowsePageType(pageType ?? '') &&
    center?.primaryFocus.includes(primaryFocus)
  ) {
    return FOCUS_BOOST
  }
  if (
    center.primaryFocus.includes(primaryFocus) &&
    center.primaryFocus === PrimaryFocus.EATING_DISORDERS
  ) {
    return MATCHED_EATING_DISORDERS_BOOST
  }
  if (
    center.primaryFocus.includes(primaryFocus) &&
    center.primaryFocus === PrimaryFocus.BEHAVIORAL_ADDITION
  ) {
    return MATCHED_BEHAVIORAL_ADDICTION_BOOST
  }
  if (
    center.primaryFocus.includes(primaryFocus) &&
    (center.primaryFocus === PrimaryFocus.MENTAL_HEALTH ||
      center.primaryFocus === PrimaryFocus.SUBSTANCE_USE_AND_MENTAL_HEALTH) &&
    primaryFocus === PrimaryFocus.MENTAL_HEALTH
  ) {
    return MATCHED_MENTAL_HEALTH_BOOST
  }

  if (
    isNonEmptyString(primaryFocus) &&
    center.primaryFocus.includes(primaryFocus)
  ) {
    return FOCUS_BOOST
  }
  return NON_FOCUS_PENALTY
}
